export default function getSafariVersion(userAgent) {
  return (
    parseInt(
      ("" + (/Version\/([0-9_]{1,5})/i.exec(userAgent) || [0, ""])[1])
        ?.replace("undefined", "3_2")
        ?.replace("_", ".")
        ?.replace("_", ""),
    ) || false
  );
}
